import store from "../../../store";
import { conditionFormChecker, /*copyForm,*/ putField } from "../../../utils/form";
import lodash from "lodash";
import i18n from "../../../i18n";

import { defineAsyncComponent } from "vue";
import { createColumnInput } from "../../../components/table/c-table.logic";
import { createFields as createFieldSurveyForm } from "../survey/survey.section";

export const callSearchSurvey = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "refOrigin.id", type: "UUID", operator: "=", value: null },
    ];
    if (searchQuery) {
        where.push({ name: "refOrigin.title", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/master/survey/search", {
            criteria: {
                select: ["id", "title"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "createDate", type: "ASC" }],
            },
        })
        .then((page) => page.data);
};

export const callSearchFullSurvey = ({ id }) => {
    return store
        .dispatch("resource/v1/master/survey/search", {
            criteria: {
                select: ["**"],
                page: 0,
                size: 1000000,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                sort: [{ name: "createDate", type: "ASC" }],
                children:[
                    {
                        name: "surveyQuestions",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [
                            {
                                name: "questionChoices",
                                select: ["**"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }],
                                children: [

                                ],
                            },
                        ],
                    },
                ]
            }
        })
        .then((page) => page.data[0]);
};

const CardBorder = defineAsyncComponent(() => import("../../../components/card/CardBorder"));
const TemplateBuilder = defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder"));

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.survey.title"),
            dataIndex: "title",
            customRender: ({ record }) => <div>{record?.title}</div>,
            align: "center",
        }),
    ];
    return columns;
};

export const createFields = ({ props, data, key, isLoading }) => {
    // const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";

    return putField({
        data,
        fields: [
            // createFieldTemplateBuilder({
            //     cardBorderProp: () =>  ({ title: i18n.global.t("views.surveyAnswer.refOrigin.title"), headerSize: "small", class: "mt-3" }),
            //     visible: () => conditionFormChecker({ props, data, executeKey: "visibleSection", params: { sectionKey: "Survey" } }),
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
            //     inputProp: () => ({
            //         useForm: useForm,
            //         fields: [
            //             ...createFieldSurvey({ props, data, key, isLoading })
            //         ]
            //     })
            // }),
            {
                visible: () => conditionFormChecker({ props, data, executeKey: "visibleSection", params: { sectionKey: "SomeInfomationView" } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    const sectionSurveyForm = createFieldSurveyForm({
                        props,
                        data,
                        key: `${prefix}`,
                        isLoading,
                    });
                    if (!model) {
                        return null;
                    }
                    return (
                        <CardBorder title={model?.title}>
                            <TemplateBuilder
                                rowProp={data.rowProp}
                                useForm={data.useForm}
                                fields={sectionSurveyForm}
                                skeleton={isLoading.value}
                            ></TemplateBuilder>
                        </CardBorder>
                    );
                }
            },
        ]
    })
}

// export const createFieldSurvey = ({ props, data, key }) => {
//     const { viewOnly } = props;
//     const { useForm } = data;
//     const { modelRef } = useForm;
//     const model = key ? lodash.get(modelRef, key) : modelRef;
//     const prefix = key ? `${key}.` : "";
//     return putField({
//         data,
//         fields: [
//             createFieldSelect({
//                 visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
//                 key: `${prefix}refOrigin`,
//                 colProp: () => ({ xs: 24 }),
//                 formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
//                 label: () => i18n.global.t("model.surveyAnswer.refOrigin"),
//                 inputProp: ({ field }) =>
//                     lodash.merge(
//                         {
//                             value: model.refOrigin,
//                             "onUpdate:value": value => {
//                                 // model.refOrigin = value
//                                 const oldValue = model.refOrigin;
//                                 model.refOrigin = value;
//                                 if (oldValue) {
//                                     Modal.confirm({
//                                         title: i18n.global.t("views.request.modal.change", {
//                                             text: i18n.global.t("model.surveyAnswer.refOrigin"),
//                                         }),
//                                         autoFocusButton: "cancel",
//                                         onOk: () => {
//                                             callSearchFullSurveyById({ model, id: value?.id, data });
//                                         },
//                                         onCancel: () => {
//                                             model.refOrigin = oldValue;
//                                         },
//                                     });
//                                 } else {
//                                     callSearchFullSurveyById({ model, id: value?.id, data });
//                                 }
//                             },
//                             disabled: viewOnly,
//                             list: ({ searchQuery }) => callSearchSurvey({ searchQuery }),
//                             optLabel: "title"
//                         },
//                         conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
//                     ),
//             }),
//         ]
//     });
// };
//
// export const callSearchFullSurveyById = ({ model, id }) => {
//     setIsLoadingApp(true);
//     if (id) {
//         callSearchFullSurvey({ id }).then((survey) => {
//             // const surveyTemp = copyForm({ form: { ...survey } });
//             setIsLoadingApp(false);
//             if (id) {
//                 model.refOrigin = null
//                 model.refOrigin = survey
//             }
//         });
//     }
// };